/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropdown, { DropdownTrigger } from 'react-simple-dropdown';
import { Notification, PaginationOptions } from 'tstypes';
import Preloader from '@omilia/preloader';
import Tooltip from '@omilia/tooltip';
import Waypoint from 'react-waypoint';
import { colors } from '@omilia/theme';

import { getNotificationsUnreadCount } from 'store/services/notifications/selectors';
import { getNotificationsCount } from 'store/services/notifications/actions';
import NotificationItem from './components/NotificationItem';

import {
  SDropdown,
  SDropdownTriggerContainer,
  SDropdownContent,
  SIcon,
  SName,
  SHeader,
  STitle,
  SBody,
  SIconClose,
  SUnreadCount,
  SIconRefresh,
} from './styled';

interface Props {
  isLoading: boolean;
  count: number;
  notifications: Array<Notification>;
  paginationOptions: PaginationOptions;
  unreadCount: number;
  getNotificationsCount: () => void;
  onGetNotifications: (param?: { page: number }) => void;
  onMarkNotificationsAsRead: () => void;
  onRefreshNotifications: () => void;
}

const INTERVAL_TIMEOUT = 1 * 30 * 1000; // half minute

export class Notifications extends Component<Props> {
  dropdownRef: React.RefObject<typeof Dropdown>;

  interval: number = 0;

  constructor(props: Props) {
    super(props);
    this.dropdownRef = React.createRef();
  }

  componentDidMount() {
    const { getNotificationsCount } = this.props;
    this.interval = window.setInterval(getNotificationsCount, INTERVAL_TIMEOUT);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleClose = () => this.dropdownRef.current.hide();

  handleLoadNextNotifications = () => {
    const { onGetNotifications, paginationOptions, count } = this.props;
    const { size, page } = paginationOptions;
    const pages = Math.ceil(count / size);

    if (page < pages) {
      onGetNotifications({
        page: page + 1,
      });
    }
  };

  handleDropdownShow = () => {
    const { onGetNotifications } = this.props;
    onGetNotifications();
  };

  handleRefreshNotifications = () => {
    const { onRefreshNotifications } = this.props;

    onRefreshNotifications();
  };

  renderNotifications = (
    isLoading: Props['isLoading'],
    notifications: Props['notifications'],
  ) => {
    if (isLoading && !notifications.length) {
      return <Preloader showBackdrop />;
    }

    if (notifications.length) {
      return (
        <React.Fragment>
          {notifications.map(notification => (
            <NotificationItem
              key={notification.id}
              notification={notification}
            />
          ))}
          {isLoading && <Preloader showBackdrop />}
        </React.Fragment>
      );
    }

    return <p data-test="no-notifications">No notifications found</p>;
  };

  render() {
    const {
      isLoading,
      notifications,
      unreadCount,
      onMarkNotificationsAsRead,
    } = this.props;

    return (
      <SDropdown
        ref={this.dropdownRef}
        onHide={onMarkNotificationsAsRead}
        onShow={this.handleDropdownShow}
      >
        {/* If we will use styled components on DropDownTrigger click does not work */}
        <DropdownTrigger>
          <SDropdownTriggerContainer data-test="notifications-content">
            <Tooltip content="Notifications" placement="left">
              <span data-test="notifications-trigger">
                <SIcon className="icon-notification-bell" />
                {unreadCount && (
                  <SUnreadCount data-test="unread-notifications-count">
                    {unreadCount}
                  </SUnreadCount>
                )}
              </span>
            </Tooltip>
          </SDropdownTriggerContainer>
        </DropdownTrigger>

        <SDropdownContent>
          <SHeader>
            <STitle>
              <SIcon className="icon-notification-bell" />
              <SName>Notifications</SName>
              <SIconRefresh
                glyph="refresh"
                primaryColor={colors.COLOR_MAGENTA_800}
                size="16"
                onClick={this.handleRefreshNotifications}
              />
            </STitle>

            <Tooltip content="Close window">
              <SIconClose onClick={this.handleClose} />
            </Tooltip>
          </SHeader>
          <SBody isEmpty={notifications.length === 0}>
            {this.renderNotifications(isLoading, notifications)}
            <Waypoint onEnter={this.handleLoadNextNotifications} />
          </SBody>
        </SDropdownContent>
      </SDropdown>
    );
  }
}

const mapDispatchToProps = {
  getNotificationsCount,
};

const mapStateToProps = state => ({
  unreadCount: getNotificationsUnreadCount(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
